import React from 'react';
import { useTranslation } from 'react-i18next';

import ListResource from './ListResource.jsx';
import { getLang } from '~/commons/helpers';
import { env } from '../../config';

const api = '/api/core/participations';

const ListParticipations = () => {
  const { i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'title', label: 'School' },
          { value: 'district', label: 'District' },
        ],
        actions: {
          create: false,
          remove: false,
          find: false,
          fileExport: true,
        },
        api,
        sort: { title: 1 },
        cols: [
          {
            key: 'title',
            children: 'School',
            getter: (v, r) => getLang(r.title, lang),
          },
          {
            key: 'district',
            children: 'District',
            getter: (v) => env.districts?.[v]?.[lang] || v,
          },
          {
            key: 'participation',
            children: 'Participation',
            getter: (v) => `${v}%`,
          },
          {
            key: 'completed',
            children: 'Completed',
          },
          {
            key: 'studentCount',
            children: 'Student Count',
          },
        ],
      }}
    />
  );
};

export default ListParticipations;
